module.exports = __webpack_public_path__ + "static/media/cup_black.71a6e322.png";